<template>
  <div v-if="!$apollo.loading">
        <div v-if="player.length > 0 " class="p-4 lg:p-8 w-full">           

            <div class="w-full flex justify-center">

                <button class=" mt-5 mb-5 text-center rounded-lg p-5 bg-red-400" @click="enableEditMode">{{editButtonText}}</button>
            </div>

            <div v-if="editMode == false">

                 <div>

                    <div class="flex justify-center items-center w-full">   

                        <label>{{$t('player.playerPicture')}}: </label>
                    </div>

                    <div class="flex justify-center items-center w-full">   

                        <!-- <img :src="player[0].picture" class="mg-1 lg:ml-5 rounded-lg" height="100" id="profileImage" width="100"/> -->

                        <img :src="player[0].picture" class="mg-1 lg:ml-5 rounded-lg" height="100" id="profileImage" ref="profileImageRef" width="100"/>

                    </div>
                </div>

                <div>
                    
                    <div class="flex justify-center items-center w-full">   
                        
                        <label>{{$t('player.nickname')}} </label>
                    </div>

                    <div class="rounded lg:rounded-lg bg-blue-300 border-blue-800 border-4">

                        <label>{{player[0].nickname}}</label>
                    </div>
                </div>

                <div>
                    
                    <div class="flex justify-center items-center w-full">   
                        
                        <label>{{$t('profile.phone')}} </label>
                    </div>

                    <div class="rounded lg:rounded-lg bg-blue-300 border-blue-800 border-4">

                        <label>{{player[0].phone}}</label>
                    </div>
                </div>

                 <div class="flex flex-row justify-around w-full mt-4">
            
                    <div class="flex rounded-lg border-blue-800 border lg:border-2 p-1 lg:p-2 me-1">
                        
                        <div class="me-4">

                            <label>{{$t('player.positionOne')}}:</label>
                        </div>

                        <div class="">
                                            
                            <label v-if="$i18n.locale == 'ar'"> {{player[0].position_one.name_ar}} </label>
                            <label v-else> {{player[0].position_one.name}} </label>
                        </div>
                    </div>

                    <div class="flex rounded-lg border-blue-800 border lg:border-2 p-1 lg:p-2 ms-1">

                        <div class="me-4">

                            <label>{{$t('player.positionTwo')}}:</label>
                        </div>

                        <div class="">
                           
                            <label v-if="$i18n.locale == 'ar'"> {{player[0].position_two.name_ar}} </label>
                            <label v-else> {{player[0].position_two.name}} </label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- To Do-->
            <div v-else>

                <player-update :userId="userId" :user="user[0]" :player="player[0]"
                :footballPositions="footballPositions" :myReload="myReload"></player-update>
            </div>
        </div>

        <div v-else class="ml-5 mr-5 mb-5 lg:ml-20 lg:mr-20 lg:mb-20 items-center">

            <!-- <label><strong>{{$t('business.profileFirst')}}</strong></label> -->

            <player-form :userId="userId" :user="user[0]"
            :footballPositions="footballPositions" :myReload="myReload"></player-form>
            
        </div>
        
  </div>

  <div v-else class="w-full flex justify-center">

    <ring-loader ></ring-loader> 
  </div>
</template>

<script>

import playerForm from '../components-two/PlayerForm'

import playerUpdate from '../components-two/PlayerUpdate'


import myQueries from '../hasura/myQueries';

import twoMyQueries from '../hasura/myTwoQueries';

// import myInserts from '../hasura/twoMyInserts';
// import myDeletes from '../hasura/twoMyDeletes';

// import twoMyQueries from '../hasura/twoMyQueries';

// import myInserts from '../hasura/twoMyInserts';
import myDeletes from '../hasura/myTwoDeletes';

import { RingLoader } from 'vue-spinners-css';

import componentsHelpers from '../classes/componentHelpers';


export default {

    mounted(){

        localStorage.setItem('clientLayout3', 'player');

        this.$layoutType = 2;

        if(JSON.stringify(this.$userId) != "{}"){

            this.userId = this.$userId;

            // console.log(`$UserId: ${this.$userId}`);

            // console.log(`JSON(UserId): ${JSON.stringify(this.$userId)}`);
        }
    },

    components:{

        playerForm,
        RingLoader,
        playerUpdate
    },

    methods: {

         myReload(){

            //  console.log(`in reload`);
            location.reload();
        },

        enableEditMode(){

            this.editMode = !this.editMode;

            if(this.editMode == true)
            { 
                this.editButtonText = this.$t("profile.viewProfile");
            }
            else{

                this.editButtonText = this.$t("profile.editProfile");
            }
        },
    },

    apollo:{

        user: {

            query: myQueries.my_user_query,

            error(error){
                
                this.userInfoError = JSON.stringify(error);
            },

            update(data){

                // console.log(`users: ${JSON.stringify(data)}`);
                const userArray = [];

                userArray.push(data.token[0].user);

                return userArray;
            }
        },

        playerAndUser:{

         
            query: twoMyQueries.player_and_user_query,

            variables(){
                    
                    return{
                    
                        userId: this.$userId
                    }
            },

            update(data){

                // this.isLoading = false;
                
                // console.log(`player_and_user_query: ${JSON.stringify(data)}`);

                if(JSON.stringify(data) != '{}'){

                    if(data.two_player.length> 0)
                    {

                        this.player = data.two_player;

                    //     // this.user = data.two_player[0].user;

                    //     // if(this.user.length > 0){

                    //     //     this.email = this.user[0].email;
                    //     // }
                    }
                }    
            },

            error(error){
                

                componentsHelpers.sendError(this.$apollo, this.userId,'Pitch', 'apollo', 'brand', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                this.brandInfoError = JSON.stringify(error);
            },

            skip() {

                // console.log(`this.$userId: ${this.$userId}`)
                
                // console.log(`this.$userId: ${JSON.stringify(this.$userId)}`);

                // console.log(`this.$userId == '{}': ${JSON.stringify(this.$userId) == '{}'}`);
                return JSON.stringify(this.$userId) == '{}';
            },
        },

        footballPositions: {

            query: twoMyQueries.football_positions,

            error(error){
                
                this.userInfoError = JSON.stringify(error);
            },

            update(data){

                // console.log(`footballOptions: ${JSON.stringify(data)}`)
                return data.two_football_position;
            }
        },
    },

    data(){

        return{

            userId: JSON.stringify(this.$userId) != '{}' ? this.$userId : 0,
            user:[],
            player:[],
            footballPositions: [],
            email: '',
            editMode: false,
            editButtonText: this.$t('profile.editProfile')
        }
    }
}
</script>

<style>

</style>